/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_Kind_AssignmentInputs */



/**
* | output |
* | --- |
* | "Assignment" |
*
* @param {Promo_Ledger_Kind_AssignmentInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_kind_assignment = /** @type {((inputs?: Promo_Ledger_Kind_AssignmentInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_Kind_AssignmentInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribution")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Atribuição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnazione")
	return /** @type {LocalizedString} */ ("Assignment")
});